import styled from 'styled-components';

import { LAYOUT_CHROME } from '../../../../theme/tokens';

/* Website glyph wrapper: rest colour from the same neutral nav-icon grey the mask-based icons
   (Product / Acquisition / Operations) and the other inline glyphs use (`walletIcon` === `navIconIdle`);
   the parent nav item's active/hover `path[fill]` rule recolours it from here. The chrome's `.icon svg` /
   `.drawer-icon svg` rules size the inner svg. */
export const Glyph = styled.span`
  display: block;
  color: ${LAYOUT_CHROME.walletIcon};

  svg {
    display: block;
  }
`;
